import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import actionCableActions from '../actions'

class ProjectImportsChannel extends React.Component {
  constructor(props) {
    super(props)

    this.CHANNEL_NAME = 'ProjectImportsChannel'
  }

  componentDidMount() {
    const { consumer, projectId } = this.props

    this.channel = consumer.subscriptions.create({
      channel: this.CHANNEL_NAME,
      project_id: projectId
    }, {
      connected: () => this.onConnected(),
      disconnected: () => this.onDisconnected(),
      received: (data) => this.onDataReceived(data)
    })
  }

  componentWillUnmount() {
    if (this.channel) {
      this.onDisconnected()
      this.channel.unsubscribe()
    }
  }

  onConnected() {
    const { dispatch, projectId } = this.props

    dispatch(actionCableActions.connectedTo(this.CHANNEL_NAME, projectId))
  }

  onDataReceived(data) {
    const { dispatch, projectId } = this.props

    dispatch(actionCableActions.dataReceivedFrom(this.CHANNEL_NAME, data, projectId))
  }

  onDisconnected() {
    const { dispatch, projectId } = this.props

    dispatch(actionCableActions.disconnectedFrom(this.CHANNEL_NAME, projectId))
  }

  render() {
    return null
  }
}

ProjectImportsChannel.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  consumer: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  projectId: PropTypes.string.isRequired
}

export default connect()(ProjectImportsChannel)
